"use strict";
/***************************************************************************/
/* Interrogare Layout for Confirmit                                        */
/* Public Responsive Layout                                                */
/* Look and Feel: Whitespace                                               */
/* Rendering version: v2                                                   */
/* created: 06.04.2021 by Oliver Kötter <oliver.koetter@interrogare.de>    */
/* V1 released 14.06.2021                                                  */
/* V2 released 15.11.2021                                                  */
/* V3 released 05.05.2022                                                  */
/* V4 released 02.02.2023                                                  */
/***************************************************************************/
/*! Interrogare Layout for Confirmit */
/*! based on https://github.com/filamentgroup/loadJS
    loadJS: load a JS file asynchronously. [c]2014 @scottjehl, Filament Group, Inc. (Based on http://goo.gl/REQGQ by Paul Irish). Licensed MIT */
/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const loadJS = (src, cb, ordered) => {
    let tmp;
    const script = document.createElement("script");
    if (typeof cb === "boolean") {
        tmp = ordered;
        ordered = cb;
        cb = tmp;
    }
    script.src = src;
    script.async = !ordered;
    document.head.appendChild(script);
    if (cb && typeof cb === "function")
        script.onload = cb;
    return script;
};
/**
 * Inserts a link element to head to load an external css file
 *
 * @param {string} src URL of file to load
 */
/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const loadCSS = (src) => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = src;
    document.head.appendChild(link);
};
// inject CSS
/**
 * injects css to the bottom of the html head
 * @param cssText css text to inject
 */
/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const css = (cssText) => {
    const styleElement = document.createElement("style");
    document.head.append(styleElement);
    styleElement.textContent = cssText;
};
const getNextSibling = (element, selector) => {
    // Get the next sibling element
    let sibling = element.nextElementSibling;
    // If the sibling matches our selector, use it
    // If not, jump to the next sibling and continue the loop
    while (sibling) {
        if (sibling.matches(selector))
            return sibling;
        sibling = sibling.nextElementSibling;
    }
    return null;
};
// Grid: convert Digit plus = to <br> and digit at the end
const gridRatings = () => {
    var _a;
    if ((_a = document.querySelector(".container-question")) === null || _a === void 0 ? void 0 : _a.innerHTML.includes("irCfIgnore:GridRatings"))
        return;
    document.querySelectorAll(".cf-desktop-grid__scale-text, .cf-desktop-multi-grid__answer-text").forEach((cell) => {
        let cellHtml = cell.innerHTML;
        const re = /^([+-]?\d+) = /;
        const digit = re.exec(cellHtml);
        if (digit && (digit === null || digit === void 0 ? void 0 : digit.length) >= 2) {
            cellHtml = cellHtml.slice(digit[0].length);
            cellHtml += `<span class="ir-grid-rating">${digit[1]}</span>`;
            cell.innerHTML = cellHtml;
        }
    });
};
/**
 * Adds event listener on whole table cell on a grid
 * so you do not have to hit the radiobutton or checkbox exactly
 */
const gridCellClick = () => {
    var _a;
    if ((_a = document.querySelector(".container-question")) === null || _a === void 0 ? void 0 : _a.innerHTML.includes("irCfIgnore:GridCellClick"))
        return;
    if (typeof Confirmit === "undefined")
        return;
    document.querySelectorAll(".cf-table-layout__cell").forEach((cell) => {
        const hasInputButton = cell.querySelector(".cf-radio-answer, .cf-checkbox-answer") !== null;
        if (!hasInputButton)
            return;
        cell.addEventListener("click", (e) => {
            const currentTarget = e.currentTarget;
            const isMultiGrid = currentTarget.querySelector(".cf-desktop-multi-grid__cell-element") !== null;
            const is3DGrid = currentTarget.closest(".cf-grid-3d-desktop") !== null;
            const isBestWorst = currentTarget.closest(".cf-table-layout--max-diff") !== null;
            const clickedCell = e.target.querySelector(".cf-checkbox-answer, .cf-radio-answer");
            if (clickedCell) {
                const cellIdArray = clickedCell.id.split("_");
                // multi grid
                if (isMultiGrid) {
                    const checked = clickedCell.classList.contains("cf-checkbox-answer--selected");
                    try {
                        const questionName = cellIdArray.slice(1, -2).join("_");
                        Confirmit.page
                            .getQuestion(questionName)
                            .getInnerQuestion(`${questionName}_${cellIdArray[cellIdArray.length - 2]}`)
                            .setValue(cellIdArray[cellIdArray.length - 1], !checked);
                    }
                    catch (_ex) { /* continue regardless of error */ }
                }
                // 3DGrid
                else if (is3DGrid) {
                    const parentQuestion = clickedCell.closest(".cf-question--grid-3d");
                    const parentQuestionId = parentQuestion === null || parentQuestion === void 0 ? void 0 : parentQuestion.id;
                    if (!parentQuestionId)
                        return;
                    let innerQuestionIsGrid = false;
                    let questionName;
                    try {
                        questionName = cellIdArray.slice(1, -1).join("_");
                        if (!Confirmit.page.getQuestion(parentQuestionId).getInnerQuestion(questionName))
                            questionName = cellIdArray.slice(1, -2).join("_");
                        if (Confirmit.page.getQuestion(parentQuestionId).getInnerQuestion(questionName).type === "Grid")
                            innerQuestionIsGrid = true;
                    }
                    catch (_ex) {
                        return;
                    }
                    // single cell 3DGrid
                    if (clickedCell.classList.contains("cf-radio-answer")) {
                        if (innerQuestionIsGrid) {
                            try {
                                Confirmit.page
                                    .getQuestion(parentQuestionId)
                                    .getInnerQuestion(questionName)
                                    .setValue(cellIdArray[cellIdArray.length - 2], cellIdArray[cellIdArray.length - 1]);
                            }
                            catch (_ex) { /* continue regardless of error */ }
                        }
                        else {
                            try {
                                Confirmit.page
                                    .getQuestion(parentQuestionId)
                                    .getInnerQuestion(questionName)
                                    .setValue(cellIdArray[cellIdArray.length - 1], true);
                            }
                            catch (_ex) { /* continue regardless of error */ }
                        }
                    }
                    // multi cell 3DGrid
                    else {
                        const checked = clickedCell.classList.contains("cf-checkbox-answer--selected");
                        try {
                            Confirmit.page
                                .getQuestion(parentQuestionId)
                                .getInnerQuestion(questionName)
                                .setValue(cellIdArray[cellIdArray.length - 1], !checked);
                        }
                        catch (_ex) { /* continue regardless of error */ }
                    }
                }
                else if (isBestWorst) {
                    const parentQuestion = clickedCell.closest(".cf-question--best-worst-grid-3d");
                    const parentQuestionId = parentQuestion === null || parentQuestion === void 0 ? void 0 : parentQuestion.id;
                    if (!parentQuestionId)
                        return;
                    if (clickedCell.classList.contains("cf-radio-answer")) {
                        try {
                            const questionName = cellIdArray.slice(0, -1).join("_");
                            Confirmit.page
                                .getQuestion(parentQuestionId)
                                .getInnerQuestion(questionName)
                                .setValue(cellIdArray[cellIdArray.length - 1]);
                        }
                        catch (_ex) { /* continue regardless of error */ }
                    }
                }
                // single
                else {
                    try {
                        const questionName = cellIdArray.slice(1, -2).join("_");
                        Confirmit.page
                            .getQuestion(questionName)
                            .setValue(cellIdArray[cellIdArray.length - 2], cellIdArray[cellIdArray.length - 1]);
                    }
                    catch (_ex) { /* continue regardless of error */ }
                }
            }
        });
    });
};
/**
 * extracts the placeholder from input fields and inserts them into a new label element
 */
const addLabelsToOpenTextfields = () => {
    var _a;
    if ((_a = document.querySelector(".container-question")) === null || _a === void 0 ? void 0 : _a.innerHTML.includes("irCfIgnore:RemoveOpenPlaceholders"))
        return;
    // non accessible mode
    document.querySelectorAll(".cf-radio-answer__other[placeholder], .cf-checkbox-answer__other[placeholder], .cf-button-answer__other--inside[placeholder], .cf-desktop-grid__answer-other[placeholder]").forEach((input) => {
        const parent = input.parentElement;
        if (parent) {
            const label = document.createElement("label");
            label.htmlFor = input.id;
            label.innerHTML = input.getAttribute("placeholder") || "";
            input.removeAttribute("placeholder");
            parent.insertBefore(label, input);
        }
    });
    // accessible mode
    document.querySelectorAll(".cf-radio[aria-label], .cf-checkbox[aria-label]").forEach((ariaLabel) => {
        const inputId = ariaLabel.id.split("_control")[0] + "_other";
        const inputElement = document.getElementById(inputId);
        if (inputElement) {
            const parent = inputElement.parentElement;
            if (parent) {
                if (parent.querySelector("label"))
                    return; // skip if label already exists
                const label = document.createElement("label");
                label.htmlFor = inputElement.id;
                label.innerHTML = ariaLabel.getAttribute("aria-label") || "";
                parent.insertBefore(label, inputElement);
            }
        }
    });
};
/**
 * copies first grid cell error message to the top
 * use CSS to actually hide the grid cell's error messages
 */
const processGridErrors = () => {
    var _a;
    if ((_a = document.querySelector(".container-question")) === null || _a === void 0 ? void 0 : _a.innerHTML.includes("irCfIgnore:ProcessGridErrors"))
        return;
    if (typeof Confirmit === "undefined")
        return;
    Confirmit.page.questions.forEach((q) => {
        if (["Grid", "GridBars", "StarRating", "Grid3d"].includes(q.type)) {
            q.validationCompleteEvent.on((validationResult) => {
                if (!validationResult.isValid) {
                    let errorSource = validationResult.answerValidationResults;
                    // for multi grids use another source for errors
                    if (q.type === "Grid3d")
                        errorSource = validationResult.questionValidationResults;
                    // get error message
                    let errorMessage = "";
                    for (const avr of errorSource) {
                        if (!avr.isValid) {
                            if (avr.errors.length > 0) {
                                errorMessage = avr.errors[0].message;
                                if (errorMessage) {
                                    const error = { message: errorMessage };
                                    validationResult.errors.push(error);
                                }
                                break;
                            }
                        }
                    }
                }
            });
        }
    });
};
/**
 *  * Hide group headings whose codes starts with a "h", e.g. "h1", "h2" etc.
 */
const hideGroupHeadings = () => {
    var _a;
    if ((_a = document.querySelector(".container-question")) === null || _a === void 0 ? void 0 : _a.innerHTML.includes("irCfIgnore:HideEmptyGroupHeadings"))
        return;
    if (typeof Confirmit === "undefined")
        return;
    Confirmit.page.questions.forEach((q) => {
        // Single, Multi, Ranking
        if (["Single", "Multi", "Ranking"].includes(q.type)) {
            const domGroups = document.querySelectorAll(`#${q.id} .cf-group-heading`);
            q.answerGroups.forEach((group, index) => {
                var _a, _b;
                if (group.code.toLowerCase().startsWith("h")) {
                    domGroups[index].classList.add("ir-hidden-group-heading");
                    (_b = (_a = domGroups[index].querySelector(".cf-group-heading__title")) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.add("ir-hidden-group-heading__title");
                    const contentElement = domGroups[index].querySelector(".cf-group-heading__content");
                    if (contentElement) {
                        contentElement.classList.add("ir-hidden-group-heading__content");
                        // remove bottom-border of last answer in group
                        const lastAnswer = contentElement.querySelector(".cf-list__item:last-child");
                        if (lastAnswer)
                            lastAnswer.classList.add("ir-hidden-group__content-last-answer");
                    }
                }
            });
        }
        // Grid as accordeon
        else if (q.type === "Grid" && q.accordion) {
            document.querySelectorAll(`#${q.id} .cf-accordion-grid-answer`).forEach((accordeon) => {
                const domGroups = accordeon.querySelectorAll(".cf-group-heading");
                q.scaleGroups.forEach((group, index) => {
                    var _a;
                    if (group.code.toLowerCase().startsWith("h")) {
                        domGroups[index].classList.add("ir-hidden-group-heading");
                        (_a = domGroups[index].querySelector(".cf-group-heading__title")) === null || _a === void 0 ? void 0 : _a.classList.add("ir-hidden-group-heading__title");
                        const contentElement = domGroups[index].querySelector(".cf-group-heading__content");
                        if (contentElement) {
                            contentElement.classList.add("ir-hidden-group-heading__content");
                            // remove bottom-border of last answer in group
                            const lastAnswer = contentElement.querySelector(".cf-list__item:last-child");
                            if (lastAnswer)
                                lastAnswer.classList.add("ir-hidden-group__content-last-answer");
                        }
                    }
                });
            });
        }
        // Grid, 3D-Grid (Multi-Grid)
        else if (["Grid", "GridBars", "StarRating", "Grid3d"].includes(q.type)) {
            // lines/prompts
            const domGroupsDesktop = document.querySelectorAll(`#${q.id} .cf-table-layout__row-group`);
            const domGroupsMobile = document.querySelectorAll(`#${q.id} .cf-mobile-grid-layout .cf-group-heading`);
            q.answerGroups.forEach((group, index) => {
                var _a, _b, _c, _d;
                if (group.code.toLowerCase().startsWith("h") && domGroupsDesktop.length > 0) {
                    // desktop
                    const groupStart = domGroupsDesktop[index].querySelector(".cf-table-layout__row-group-start");
                    if (groupStart) {
                        domGroupsDesktop[index].classList.add("ir-hidden-grid-group");
                        (_a = groupStart.parentElement) === null || _a === void 0 ? void 0 : _a.querySelectorAll(".cf-table-layout__row--first-in-group .cf-table-layout__cell").forEach((cell) => {
                            cell.classList.add("ir-hidden-grid-group-heading__first-line-cell");
                        });
                        const groupEnd = (_b = groupStart.parentElement) === null || _b === void 0 ? void 0 : _b.querySelector(".cf-table-layout__row-group-end");
                        if (groupEnd)
                            groupEnd.classList.add("ir-hidden-group-ending");
                    }
                    // mobile
                    if (q.type === "Grid3d") {
                        const questions = document.querySelectorAll(`#${q.id} .cf-grid-3d-mobile__inner-question`);
                        questions === null || questions === void 0 ? void 0 : questions.forEach((question) => {
                            var _a, _b;
                            const header = question.querySelectorAll(".cf-group-heading")[index];
                            header.classList.add("ir-hidden-group-heading");
                            (_a = header.querySelector(".cf-group-heading__title")) === null || _a === void 0 ? void 0 : _a.classList.add("ir-hidden-group-heading__title");
                            (_b = header.querySelector(".cf-group-heading__content")) === null || _b === void 0 ? void 0 : _b.classList.add("ir-hidden-group-heading--mobile__content");
                        });
                        console.log("not yet implemented");
                    }
                    else {
                        (_c = domGroupsMobile[index].querySelector(".cf-group-heading__title")) === null || _c === void 0 ? void 0 : _c.classList.add("ir-hidden-group-heading__title");
                        (_d = domGroupsMobile[index].querySelector(".cf-group-heading__content")) === null || _d === void 0 ? void 0 : _d.classList.add("ir-hidden-group-heading--mobile__content");
                    }
                }
            });
            // columns/scale
            if (q.type !== "Grid3d") {
                const answersDom = document.querySelectorAll(`#${q.id} .cf-mobile-grid-answer`);
                if (answersDom.length > 0) {
                    q.answers.forEach((_, answerIndex) => {
                        const domScaleGroupHeadings = answersDom[answerIndex].querySelectorAll(".scale-group-heading");
                        const domScaleGroupEndings = answersDom[answerIndex].querySelectorAll(".scale-group-end");
                        q.scaleGroups.forEach((group, index) => {
                            if (group.code.toLowerCase().startsWith("h")) {
                                domScaleGroupHeadings[index].classList.add("ir-hidden-group-heading__title");
                                domScaleGroupEndings[index].classList.add("ir-hidden-group-ending");
                            }
                            else {
                                const nextAnswer = getNextSibling(domScaleGroupEndings[index], ".cf-list__item");
                                if (nextAnswer)
                                    nextAnswer.classList.add("ir-answer-after-hidden-group-ending");
                            }
                        });
                    });
                }
            }
        }
    });
};
// number: px
// string: css unit
// boolean: true = auto width, false = no width setting
// undefined: auto width
// declare let FirstColumnWidth: number | string | boolean | undefined;
/**
 * sets first column for Numeric lists and Text lists (only for desktop)
 * @param FirstColumnWidth The width of the first column
 *   - undefined: auto width (may only be called from Survey Layout )
 *   - number: width in px
 *   - string: width in valid css unit
 *   - boolean: true=auto width, false=do nothing
 */
const irListWidth = (FirstColumnWidth) => {
    // If auto called by SurveyLayout (with no argument, i.e. undefined)
    // and also manually called in question: do nothing here in Survey Layout
    if (typeof FirstColumnWidth === "undefined") {
        const lastScriptNode = Array.from(document.querySelectorAll("script")).pop();
        if (lastScriptNode && lastScriptNode.innerText.includes("irListWidth"))
            return;
    }
    // type boolean and set to false -> do nothing
    if (typeof FirstColumnWidth === "boolean" && !FirstColumnWidth)
        return;
    if (typeof Confirmit === "undefined")
        return;
    Confirmit.page.questions.forEach((q) => {
        let selector = "";
        if (q.type === "NumericList")
            selector = `#${q.id}.cf-question--numeric-list .cf-grid-layout__row-text:first-child`;
        else if (q.type === "OpenTextList")
            selector = `#${q.id}.cf-question--open-list .cf-grid-layout__row-text:first-child`;
        else
            return;
        let width = "";
        if (typeof FirstColumnWidth === "undefined" || (typeof FirstColumnWidth === "boolean" && FirstColumnWidth)) {
            // find widest row
            let maxWidth = 0;
            document.querySelectorAll(selector).forEach((row) => {
                // reset former width if resized
                row.style.width = "";
                if (row.clientWidth > maxWidth)
                    maxWidth = row.clientWidth;
            });
            if (maxWidth > 0)
                width = `${maxWidth + 2}px`;
            else
                width = "0";
        }
        else if (typeof FirstColumnWidth === "number" || !isNaN(Number(FirstColumnWidth)))
            width = `${FirstColumnWidth}px`;
        else if (typeof FirstColumnWidth === "string")
            width = FirstColumnWidth;
        // set all row widths
        document.querySelectorAll(selector).forEach((row) => {
            row.style.width = width;
            if (width === "0")
                row.style.display = "none";
        });
        // reset grid row heights on multi columns grid
        const grid = document.querySelector(`#${q.id} .cf-grid-layout--multi-columns`);
        if (grid) {
            // replace 1fr to auto, otherwise the row is too high
            grid.style.gridTemplateRows = grid.style.gridTemplateRows.replace("1fr", "auto");
        }
        // check if there is horizontal scrollbar
        const rows = document.querySelectorAll(`#${q.id} .cf-grid-layout__row`);
        const questionContainer = document.querySelector(`#${q.id} .cf-question__content`);
        if (questionContainer) {
            rows.forEach((row) => {
                // unconditionally remove the "ir-cf-mobile-list" class
                row.classList.remove("ir-cf-mobile-list");
                // there is a scrollbar --> fall back to flexbox columns by adding the "ir-cf-mobile-list" class
                if (questionContainer.scrollWidth > questionContainer.clientWidth)
                    row.classList.add("ir-cf-mobile-list");
            });
        }
    });
};
const inputFieldWidths = () => {
    var _a;
    if ((_a = document.querySelector(".container-question")) === null || _a === void 0 ? void 0 : _a.innerHTML.includes("irCfIgnore:InputFieldWidths"))
        return;
    if (typeof Confirmit === "undefined")
        return;
    Confirmit.page.questions.forEach((q) => {
        if (q.type === "Numeric" || q.type === "NumericList") {
            const maxWidth = q.numeric.precision;
            document.querySelectorAll(`#${q.id} .cf-text-box--number`).forEach((input) => {
                // automatically add width if there isn't already one
                if (!input.style.width && maxWidth) {
                    input.style.width = `${maxWidth + 2}ch`;
                }
                // set step attribute, otherwise input is invalid if there are decimals
                if (q.numeric.scale > 0 && !input.getAttribute("step"))
                    input.setAttribute("step", String(1 / (Math.pow(10, q.numeric.scale))));
            });
            // set width of auto sum field
            const firstInput = document.querySelector(`#${q.id} .cf-numeric-list-answer__input`);
            const autoSumField = document.querySelector(`#${q.id} .cf-numeric-list-auto-sum__value`);
            if (firstInput && autoSumField)
                autoSumField.style.width = `${firstInput.offsetWidth}px`;
        }
    });
};
/**
 * If there is no rows attribute on an open question add it with the default value of "5".
 */
const textareaHeight = () => {
    var _a;
    if ((_a = document.querySelector(".container-question")) === null || _a === void 0 ? void 0 : _a.innerHTML.includes("irCfIgnore:TextareaHeight"))
        return;
    if (typeof Confirmit === "undefined")
        return;
    Confirmit.page.questions.forEach((q) => {
        if (q.type === "OpenText") {
            document.querySelectorAll(`#${q.id} .cf-text-area`).forEach((textarea) => {
                // because of "box-sizing: border-box" add 20px for 2x1px border + 2x8px padding
                if (!textarea.getAttribute("rows"))
                    textarea.setAttribute("rows", "5");
            });
        }
    });
};
/**
 * Adds event listener to the last text or number input element to submit the form on pressing enter
 */
const submitOnEnter = () => {
    var _a;
    if ((_a = document.querySelector(".container-question")) === null || _a === void 0 ? void 0 : _a.innerHTML.includes("irCfIgnore:SubmitOnEnter"))
        return;
    // get last input field
    const input = Array.from(document.querySelectorAll(".cf-text-box")).pop();
    if (input) {
        input.addEventListener("keydown", (e) => {
            const code = e.code;
            if (code === "Enter" || code === "NumpadEnter") {
                const nextButton = document.querySelector(".cf-navigation-next");
                if (nextButton)
                    nextButton.click();
            }
        });
    }
};
const smallAdjustments = () => {
    var _a, _b, _c, _d;
    // qid in html head title
    const action = (_a = document.querySelector("form")) === null || _a === void 0 ? void 0 : _a.getAttribute("action");
    if ((action === null || action === void 0 ? void 0 : action.startsWith("/extwix/test_")) || (action === null || action === void 0 ? void 0 : action.startsWith("/extwix/extquicktest_"))) {
        const qid = (_b = document.querySelector(".cf-question")) === null || _b === void 0 ? void 0 : _b.id;
        if (qid)
            document.title = `${qid} - ${document.title}`;
    }
    // add class "internalQuickTest" to body element
    if (window.frameElement !== null)
        document.body.classList.add("internal-quicktest");
    // add TEST-DISPLAY to hidden questions
    const textElements = document.querySelectorAll(".cf-question__text");
    textElements.forEach((element) => {
        var _a, _b;
        if (element.innerText.startsWith("[HIDDEN DATA]")) {
            (_a = element.closest(".cf-question")) === null || _a === void 0 ? void 0 : _a.classList.add("ir-hidden-question");
            (_b = element.querySelector("span")) === null || _b === void 0 ? void 0 : _b.classList.add("ir-hidden-question--header");
        }
    });
    // remove back button from DOM if it is hidden
    if (!((_c = document.querySelector(".container-question")) === null || _c === void 0 ? void 0 : _c.innerHTML.includes("irCfIgnore:RemoveBackbutton"))) {
        const backButtonElement = document.querySelector(".cf-navigation-back");
        if (backButtonElement) {
            const style = getComputedStyle(backButtonElement).getPropertyValue("display");
            if (style === "none")
                backButtonElement.remove();
        }
    }
    // prevent pasting text answers
    if (!((_d = document.querySelector(".container-question")) === null || _d === void 0 ? void 0 : _d.innerHTML.includes("irCfIgnore:PreventPaste"))) {
        document.querySelectorAll(".cf-text-box, .cf-text-area").forEach((tb) => {
            if (tb.classList.contains("allow-paste"))
                return; // allow pasting if class allow-paste exists
            // set in global script via document.querySelectorAll(".cf-text-box, .cf-text-area").forEach(textbox => textbox.classList.add("allow-paste"));
            tb.addEventListener("paste", (e) => {
                e.preventDefault();
            });
        });
    }
};
/**
 * Look for Grid Scale Group Headings and insert a separator after it
 */
const gridSeparators = () => {
    if (typeof Confirmit === "undefined")
        return;
    Confirmit.page.questions.forEach((q) => {
        var _a;
        if ((_a = document.getElementById(q.id)) === null || _a === void 0 ? void 0 : _a.innerHTML.includes("irCfIgnore:GridSeparators"))
            return;
        if (q.type === "Grid") {
            const table = document.querySelector(`#${q.id} .cf-desktop-grid > table`);
            if (!table)
                return;
            const domColumnGroups = document.querySelectorAll(`#${q.id} .cf-table-layout__cell--column-group`);
            let offset = 0;
            let cellInserted = false;
            q.scaleGroups.forEach((group, index) => {
                if (!group.code.toLowerCase().startsWith("h")) {
                    const separatorPosition = Number(domColumnGroups[index].getAttribute("colspan"));
                    if (separatorPosition === 0)
                        return;
                    offset += separatorPosition;
                    cellInserted = false;
                    // insert separator in column-group
                    let separatorCell = document.createElement("td");
                    separatorCell.className = "ir-grid-separator";
                    domColumnGroups[index].after(separatorCell);
                    // insert separator in thead
                    // const secondHeaderRow = table.querySelectorAll("thead > tr")[1];
                    const secondHeaderRow = table.querySelector(".cf-table-layout__row--head");
                    if (secondHeaderRow) {
                        separatorCell = document.createElement("td");
                        separatorCell.className = "ir-grid-separator";
                        const cells = secondHeaderRow.querySelectorAll("th, td");
                        if (cells.length > offset)
                            cells[offset].after(separatorCell);
                    }
                    // insert separator in every row in tbody
                    table.querySelectorAll("tbody > tr").forEach((row) => {
                        separatorCell = document.createElement("td");
                        separatorCell.className = "ir-grid-separator";
                        const cells = row.querySelectorAll("th, td");
                        if (cells.length > offset) {
                            cells[offset].after(separatorCell);
                            cellInserted = true;
                        }
                        // increase colspan in Group Headings
                        if (row.classList.contains("cf-table-layout__row-group-start")
                            || row.classList.contains("cf-table-layout__row-group-end")
                            || row.classList.contains("cf-table-layout__head-spacer")) {
                            const td = row.querySelector("td, th");
                            if (td) {
                                const colspan = Number(td.getAttribute("colspan"));
                                if (colspan > 0)
                                    td.setAttribute("colspan", String(colspan + 1));
                            }
                        }
                    });
                    if (cellInserted)
                        offset++;
                }
            });
        }
    });
};
/**
 * adds an empty separator column
 * @param columnNumber column number after which a new empty column is inserted
 */
/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const addColumnSeparator = (columnNumber) => {
    // desktop
    document.querySelectorAll(`.cf-table-layout__cell:nth-child(${columnNumber + 1})`).forEach((cell) => {
        const newCell = document.createElement("td");
        newCell.className = "ir-grid-separator";
        // insert width only in header, not in every row
        // if (cell.tagName === "TH") newCell.style.width = newWidth;
        if (cell.parentNode && cell.nextSibling)
            cell.parentNode.insertBefore(newCell, cell.nextSibling);
    });
    // mobile
    document.querySelectorAll(".cf-mobile-grid-layout__answer-content .cf-list__item:last-child").forEach((row) => {
        row.style.marginTop = "1rem";
    });
};
/**
 * Hide next button for a given number of seconds
 * @param seconds number of seconds after the button should be shown again
 */
/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const DeactivateNextButton = (seconds) => {
    const nextbutton = document.querySelector(".cf-navigation-next");
    if (!nextbutton)
        return;
    nextbutton.disabled = true;
    const oldLabel = nextbutton.textContent;
    let countdown = seconds;
    nextbutton.textContent = String(countdown);
    const timer = setInterval(() => {
        nextbutton.textContent = String(--countdown);
        if (countdown === 0) {
            nextbutton.textContent = oldLabel;
            nextbutton.disabled = false;
            clearInterval(timer);
        }
    }, 1000);
};
/**
 * auto submit form once all page's question results are valid
 */
/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const autoSubmit = () => {
    if (typeof Confirmit === "undefined")
        return;
    Confirmit.page.questions.forEach((q) => {
        q.changeEvent.on(() => {
            Confirmit.page.questions.forEach((q2) => {
                if (q2.validate().isValid)
                    Confirmit.page.next();
            });
        });
    });
};
const appendLOIToFormAction = () => {
    if (window.disableLOI)
        return; // var disableLOI = true to disable this
    if (typeof Confirmit === "undefined")
        return;
    // get all questions
    let questions = Confirmit.page.questions;
    // if more than one, get id of first "real" question (not info) on page
    if (questions.length > 1)
        questions = Confirmit.page.questions.filter((q) => q.type !== "Info");
    let question;
    // if none left, take first on page
    if (questions.length === 0 && Confirmit.page.questions.length > 0)
        question = Confirmit.page.questions[0];
    else
        question = questions[0];
    const id = question.id || "";
    const endTime = new Date();
    const form = document.querySelector("form");
    if (form) {
        let action = form.getAttribute("action");
        if (action) {
            if (action.includes("?"))
                action += "&";
            else
                action += "?";
            /* eslint no-use-before-define: "off" */
            form.setAttribute("action", action + `loq=${Math.round((endTime.getTime() - startTime.getTime()) / 1000)}&id=${id}&`);
        }
    }
};
/**
 * hide radiobuttons or checkboxes in single grid or multi grid cells
 * @param {string} question question id
 * @param {string} rows comma separated string if row codes
 * @param {string} columns comma separated string if column codes
 */
/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const hideGridCells = (question, rows, columns) => {
    const _rows = [];
    const _columns = [];
    // get rows
    String(rows)
        .split(",")
        .forEach((range) => {
        const rangeArray = range.trim().split("-");
        if (rangeArray.length === 1)
            _rows.push(rangeArray[0]);
        else {
            for (let i = Number(rangeArray[0]); i <= Number(rangeArray[1]); i++) {
                _rows.push(String(i));
            }
        }
    });
    // get columns
    String(columns)
        .split(",")
        .forEach((range) => {
        const rangeArray = range.split("-");
        if (rangeArray.length === 1)
            _columns.push(rangeArray[0]);
        else {
            for (let i = Number(rangeArray[0]); i <= Number(rangeArray[1]); i++) {
                _columns.push(String(i));
            }
        }
    });
    // processing
    _rows.forEach((row) => {
        _columns.forEach((column) => {
            var _a;
            const controlElement = document.getElementById(`desktop_${question}_${row}_${column}_control`);
            const tableCell = controlElement === null || controlElement === void 0 ? void 0 : controlElement.closest(".cf-table-layout__cell");
            const hideElement = controlElement === null || controlElement === void 0 ? void 0 : controlElement.closest(".cf-table-layout-cell");
            if (tableCell && hideElement) {
                tableCell.style.pointerEvents = "none";
                hideElement.style.display = "none";
                const mobileElement = (_a = document.getElementById(`mobile_${question}_${row}_${column}_control`)) === null || _a === void 0 ? void 0 : _a.closest(".cf-list__item");
                if (mobileElement)
                    mobileElement.style.display = "none";
            }
        });
    });
};
/**
 * set progressbar to given percentage
 * @param {number} percent percentage to set the progress bar to
 */
/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const setProgressBar = (percent) => {
    const progressbarElement = document.querySelector(".cf-progress__indicator");
    if (!progressbarElement)
        return;
    const progressIndicatorElement = document.querySelector(".cf-progress__indicator");
    if (progressIndicatorElement)
        progressIndicatorElement.style.width = `${percent}%`;
    const textElement = document.querySelector(".cf-progress__text-for-acc");
    if (!textElement)
        return;
    const regex = String.fromCharCode(94) + "(.+?)(\\d+%)$";
    const matches = textElement.innerText.match(regex);
    if (matches && matches.length > 2)
        textElement.innerText = matches[1] + percent + "%";
};
/**
 * adds key/value pair to querystring of form action
 * @param {string} key key of key/value pair
 * @param {string} value value of key/value pair
 * @returns {void}
 */
/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const addToFormAction = (key, value) => {
    const form = document.querySelector("form");
    if (!form)
        return;
    let action = form.getAttribute("action");
    if (!action)
        return;
    if (action.includes("?"))
        action += "&";
    else
        action += "?";
    const keyIndex = action.indexOf(key + "=");
    if (keyIndex > -1)
        action = action.substring(0, keyIndex);
    form.setAttribute("action", action + key + "=" + encodeURIComponent(value));
};
/**
 * Change label for Include "Don’t know"/"Prefer not to answer" options
 *
 * @param {number} no 1 = DK, 2 = Ref
 * @param {string} question question id
 * @param {string} label new label
 * @returns {void}
 */
/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const irSetOtherLabel = (no, question, label) => {
    let id = "";
    if (no == 1)
        id = "dk"; // eslint-disable-line eqeqeq
    else
        id = "ref";
    const element = document.querySelector(`#${question}_${id}_text`);
    if (element)
        element.innerHTML = label;
};
/***************************************************************************/
/* Main event listeners                                                    */
/***************************************************************************/
// runs when page is loaded
const startTime = new Date();
document.addEventListener("DOMContentLoaded", () => {
    var _a;
    // Grid
    gridRatings(); // <!--irCfIgnore:GridRatings-->
    gridSeparators(); // <!--irCfIgnore:GridSeparators-->
    gridCellClick(); // <!--irCfIgnore:GridCellClick-->
    processGridErrors(); // <!--irCfIgnore:ProcessGridErrors-->
    hideGroupHeadings(); // <!--irCfIgnore:HideEmptyGroupHeadings-->
    addLabelsToOpenTextfields(); // <!--irCfIgnore:RemoveOpenPlaceholders-->
    // sets first column for Numeric lists and Text lists (only for desktop)
    irListWidth(); // irListWidth(false);
    inputFieldWidths(); // <!--irCfIgnore:InputFieldWidths-->
    textareaHeight(); // <!--irCfIgnore:TextareaHeight-->
    submitOnEnter(); // <!--irCfIgnore:SubmitOnEnter-->
    smallAdjustments();
    (_a = document.querySelector(".cf-navigation__button")) === null || _a === void 0 ? void 0 : _a.addEventListener("click", appendLOIToFormAction); // var disableLOI = true; to disable this
});
// runs when window is resized
window.addEventListener("resize", () => {
    // sets first column for Numeric lists and Text lists (only for desktop)
    irListWidth();
});
//# sourceMappingURL=deutsche-bahn-v6.js.map